<template>
  <div class="container">
    <div class="row">

      <div class="col-md-12">
        <div class="radio-inline mb-2">
          <div class="custom-label" style="display:inline-block;margin-right:30px;">
            {{ $static('order.ostatus', 'Статус замовлення') }}</div>
          <!-- checkbox-->
          <div class="default-radio">
            <input id="status_all" type="radio" name="status" v-model="filter.status" value="">
            <label for="status_all">{{ $static('ords.all', 'Всі') }}</label>
          </div>
          <div class="default-radio" v-for="(status, index) in statusList" :key="index">
            <input :id="'status' + index" type="radio" name="status" v-model="filter.status" :value="status.value">
            <label :for="'status' + index">{{ $dynamic(status, status.label, 'label') }}</label>
          </div>
          <!--end  checkbox-->
        </div>

        <div class="large-button-panel order-sort-panel">
          <div class="search-panel w-30">
            <!--search panel-->
            <div class="search-group">
              <input type="text" name="input_search_orders" class="input-search form-control custom-input"
                v-model="filter.search" @keydown.enter="getItems"
                :placeholder="$static('order.t1', 'Знайти за ідентифікатором покупця/квитанцією/ідентифікатором')">
              <button class="search-btn" @click="getItems">
                <span class="icon icon-search"></span>
              </button>
            </div>
            <!-- end search panel-->
          </div>
          <div class="group-holder w-15">
            <div class="text-icon-group  dropdown-toggle" id="pay_status" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="true">
              <span class="name">{{ $static('order.pstatus', 'Статус оплати') }}</span>
              <span class="icon icon-down"></span>
            </div>
            <ul class="dropdown-menu custom-dropdown" aria-labelledby="pay_status">
              <li>
                <!-- checkbox-->
                <div class="default-checkbox">
                  <input id="all_pay_status" type="checkbox" :checked="filter.pay_status.length === 0"
                    @change="filter.pay_status = []">
                  <label for="all_pay_status">{{ $static('order.all', 'Увесь') }}</label>
                </div>
                <!--end  checkbox-->
              </li>
              <li>
                <!-- checkbox-->
                <div class="default-checkbox">
                  <input id="paid_pay_status" type="checkbox" v-model="filter.pay_status" value="pay">
                  <label for="paid_pay_status">{{ $static('pstatus.pay', 'Сплачено') }}</label>
                </div>
                <!--end checkbox-->
              </li>
              <li>
                <!-- checkbox-->
                <div class="default-checkbox">
                  <input id="not_paid_pay_status" type="checkbox" v-model="filter.pay_status" value="npay">
                  <label for="not_paid_pay_status">{{ $static('pstatus.npay', 'Очікує сплати') }}</label>
                </div>
                <!--end checkbox-->
              </li>
              <li>
                <!-- checkbox-->
                <div class="default-checkbox">
                  <input id="cancel_paid_pay_status" type="checkbox" v-model="filter.pay_status" value="cpay">
                  <label for="cancel_paid_pay_status">{{ $static('pstatus.cpay', 'Відміна') }}</label>
                </div>
                <!--end checkbox-->
              </li>
            </ul>
          </div>
          <div class="group-holder w-20">
            <div class="datepicker-custom">
              <v-date-picker @click.stop.prevent="" v-model.lazy="orderDate" is-range :locale="datePickerLocale">
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="d-flex justify-content-between items-center" v-if="orderDate.start && orderDate.end">
                    <input :value="inputValue.start" v-on="inputEvents.start"
                      class="form-control custom-input datapicker-input " style="width:49%" />
                    <input :value="inputValue.end" v-on="inputEvents.end"
                      class="form-control custom-input datapicker-input " style="width:49%" />
                  </div>
                  <div class="text-icon-group" v-on="inputEvents.start" v-else>
                    <span class="name">{{ $static('order.time', 'Час замовлення') }}</span>
                    <span class="icon icon-calendar"></span>
                  </div>
                </template>
              </v-date-picker>
            </div>


            <!--            <div class="dropdown-menu" aria-labelledby="time_area">-->
            <!--              -->
            <!--              <div class="button-holder">-->
            <!--                <button class="default-btn" @click="getItems">-->
            <!--                  <span class="text">Применить</span>-->
            <!--                </button>-->
            <!--              </div>-->
            <!--            </div>-->

          </div>
          <div class="group-holder align-items-center justify-content-between d-flex w-30">
            <span class="name" style="margin-right:10px">{{ $static('order.price', 'Ціна') }}</span>
            <div class="d-flex justify-content-between align-items-center w-90">
              <input type="text" class="form-control custom-input" style="width:48%;"
                :placeholder="$static('orders.from', 'от')" v-model.number="priceLow">
              <input type="text" class="form-control custom-input" style="width:48%;"
                :placeholder="$static('orders.to', 'до')" v-model.number="priceHigh">
            </div>

          </div>
          <!--<div class="group-holder w-20">
            <div class="text-icon-group  dropdown-toggle" id="price_area" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <span class="name">Цена</span>
              <span class="icon icon-down"></span>
            </div>
            <ul class="dropdown-menu custom-dropdown" aria-labelledby="price_area">
              <li>
                <div class="form-group">
                  <input type="text" class="form-control custom-input" placeholder="от" v-model.number="priceLow">
                </div>
              </li>
              <li>
                <div class="form-group">
                  <input type="text" class="form-control custom-input" placeholder="до" v-model.number="priceHigh">
                </div>
              </li>
              <li>
                <div class="button-holder" @click="getItems">
                  <button class="default-btn">
                    <span class="text">Применить</span>
                  </button>
                </div>
              </li>
            </ul>
          </div>-->
        </div>

        <div class="table-wrapper">
          <div class="table-responsive">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th>{{ $static('order.e1', 'Номер замовлення') }}</th>
                  <th>{{ $static('order.e2', 'Замовити товар') }}</th>
                  <th>{{ $static('order.e3', 'Вартість') }}, {{ $store.getters.symbol }}</th>
                  <th class="text-center">{{ $static('order.e4', 'Статус замовлення') }}</th>
                  <th>{{ $static('order.e5', 'Статус оплати') }}</th>
                  <th>{{ $static('order.e6', 'Час замовлення') }}</th>
                  <th>{{ $static('order.e7', 'Ідентифікатор користувача') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="index" @click="openEditor(item)" style="cursor: pointer">
                  <td scope="row" class="w-standart">
                    <a href="javascript:void(0)" class="bold" @click="openEditor(item)">#{{ item.id }}</a>
                  </td>
                  <td>
                    <div class="text">{{ getItemTitle(item) }}</div>
                  </td>
                  <td class="w-standart">{{ item.total }}</td>
                  <td class="label-td text-center">
                    <div class="label-status order-status" :class="status[item.status]">{{ statusTranslate(item.status)
                      }}
                    </div>
                  </td>
                  <td class="label-td text-center">
                    <div class="label-status pay-status" :class="payClass(item.pay_status)">
                      {{ payTranslate(item.pay_status) }}
                    </div>
                  </td>
                  <td class="w-standart">{{ item.created_at.toLocaleString(currentLang) }}</td>
                  <td class="w-standart" style="cursor: pointer">
                    <!--                  @click="event => openChat(event, item)"-->
                    <div class="user-id-prev" v-if="item.user">
                      <!--                    <span class="avatar bg" style="background-image: url(/images/avatar.png);"></span>-->
                      <span class="name">{{ item.user.telegram_id }}</span>
                    </div>
                  </td>
                  <td class="w-standart">
                    <div class="actions-box">
                      <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="left"
                        style="white-space: nowrap">
                        <button class="btn-icon btn-rounded btn-icon-transparent order_edit">
                          <span class="icon icon-edit"></span>
                        </button>
                      </Popper>

                      <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="left"
                        style="white-space: nowrap">
                        <button @click.prevent.stop="openRemoveConfirmationModal(item)"
                          class="btn-icon btn-rounded btn-icon-transparent order_edit">
                          <span class="icon icon-trash"></span>
                        </button>
                      </Popper>
                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pagination-panel table-pagination" v-if="pages.length > 1">
          <nav>
            <router-link :to="{ name: 'Orders', params: { page: Math.max(pageIndex - 1, 1) } }" class="previous extreme"
              :class="{ 'disabled': pageIndex < 2 }">
              <span class="icons icon-left"></span>
            </router-link>
            <ul class="pagination pagination-list">
              <li v-for="(page, index) in pages" :key="index" :class="{ 'active': pageIndex === page }">
                <router-link :to="{ name: 'Orders', params: { page: page } }">{{ page }}</router-link>
              </li>
            </ul>
            <router-link :to="{ name: 'Orders', params: { page: Math.min(pageIndex + 1, pageAmount) } }"
              class="end extreme" :class="{ 'disabled': pageIndex > pageAmount - 1 }">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <div class="remove-order-confirmation-modal">
      <div class="modal-dialog modal-dialog-centered d-flex align-items-center" style="height:90%" role="document">
        <div class="modal-content w-100">
          <div class="modal-header modal-header-noborder">
            <button type="button" class="close" @click.prevent="closeRemoveConfirmationModal">
              <span class="icon icon-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <h2 style="text-align: center">{{ $static('order.delete-order-title', 'Видалення замовлення') }}</h2>
            <div class="modal-text text-center">
              <p><strong>{{ $static('order.delete-order-are-you-sure',
                'Ви впевнені, що хочете видалити замовлення ? ') }}</strong></p>
              <p style="color: red">
                {{ $static('order.delete-order-text',
                  'Ця дія є невідворотною. Видалене замовлення не можна буде відновити.Воно буде перенесене в спеціальний архів, який стане доступним у майбутніх оновленнях системи.') }}
              </p>
            </div>
            <div class="button-holder button-holder-center-container">
              <button class="transparent-btn default-btn" @click="closeRemoveConfirmationModal">
                <span class="text">{{ $static('order.delete-cancel-btn', 'Відмінити') }}</span>
              </button>
              <button class="default-btn btn-remove" @click="remove()">
                <span class="text">{{ $static('order.modal-delete-btn', 'Видалити') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import api from '@/api'
import ChatWidget from '../components/ChatWidget';
import OrderEditItem from '../components/OrderEditItem';
// import CatalogProductPreview from '../components/CatalogProductPreview';
// import EditItemAdmin from '../components/EditItemAdmin';

const pageSlotsAmount = 5;

export default {
  name: 'Orders',
  components: { ChatWidget, OrderEditItem },
  props: ['page'],
  data() {
    return {
      selected: undefined,
      filter: {
        page: 1,
        perPage: 10,
        price: [],
        pay_status: [],
        category: '',
        status: '',
        color: [],
        size: [],
        add_between: undefined,
        search: undefined
      },
      items: [],
      total: 0,
      importFile: undefined,
      sortBy: 'time',
      isList: true,
      orderDate: {
        // start: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        // end  : new Date()
      },
      status: {
        'new': 'label-new',
        'process': 'label-send',
        'delivery': 'label-delivered',
        'progress': 'label-proccess',
        'back': 'label-return',
        'cancel': 'label-cancel'
      },
      payStatusClassList: {
        'pay': 'label-success',
        'cpay': 'label-cancel',
        'npay': 'label-proccess'
      }
    }
  },
  computed: {
    statusList() {
      return this.$store.getters.statusList
    },
    payStatusList() {
      return this.$store.getters.payStatusList
    },
    pageCount() {
      return Math.ceil(this.total / this.filter.perPage)
    },
    priceLow: {
      get() {
        return this.filter.price.length === 2 && this.filter.price[0] > -1 ? this.filter.price[0] : null;
      },
      set(value) {
        if (this.filter.price.length !== 2) {
          this.filter.price = [-1, -1]
        }
        this.filter.price[0] = value ? value : -1
      }
    },
    priceHigh: {
      get() {
        return this.filter.price.length === 2 && this.filter.price[1] > -1 ? this.filter.price[1] : null;
      },
      set(value) {
        if (this.filter.price.length !== 2) {
          this.filter.price = [-1, -1]
        }
        this.filter.price[1] = value ? value : -1
      }
    },
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },
    pageAmount() {
      return Math.ceil(this.total / this.filter.perPage);
    },
    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
    currentLang() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    },
    datePickerLocale() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },

  async mounted() {
    window.$('.select-custom').selectpicker();

    await this.getItems();
    await this.fetchPlugins();

    window.onSaveOrder = this.onSave;
    window.onAddOrder = this.onAdd;
  },
  methods: {
    statusTranslate(status) {
      let idx = this.statusList.findIndex(i => i.value === status);
      if (idx > -1) {
        return this.statusList[idx].label
      }
      return status
    },
    payTranslate(status) {
      let idx = this.payStatusList.findIndex(i => i.value === status);
      if (idx > -1) {
        return this.payStatusList[idx].label
      }
      return status
    },
    payClass(status) {
      return this.payStatusClassList[status] ? this.payStatusClassList[status] : status
    },

    async fetchPlugins() {
      try {
        const response = await api.get('/api/plugin');
        const data = response.data;

        const deliveryList = data.filter(i => i.type === 'delivery' && i.status === 'active');
        this.$store.commit('setDeliveryOptions', deliveryList);

        const paymentList = data.filter(i => i.type === 'payment' && i.status === 'active');
        this.$store.commit('setPayments', paymentList);

      } catch (error) {
        console.error("Ошибка загрузки плагинов:", error);
      }
    },
    async getItems() {
      let filter = Object.assign({}, this.filter);

      if (this.orderDate && this.orderDate.start && this.orderDate.end) {
        filter = Object.assign(filter, {
          created_at: [
            Math.floor(this.orderDate.start.getTime() / 1000),
            Math.floor(this.orderDate.end.getTime() / 1000)
          ]
        });
        filter.created_at[0] -= filter.created_at[0] % 86400;
        filter.created_at[1] += 86400 - (filter.created_at[1] % 86400);
      }

      try {
        const response = await api.post('/api/order/filter', { filter, sortBy: this.sortBy });
        const data = response.data;

        this.items = data.result.map(i => {
          i.created_at = new Date(i.created_at);
          i.updated_at = new Date(i.updated_at);
          return i;
        });

        this.filter.page = data.page;
        this.total = data.total;
      } catch (error) {
        console.error('Error fetching items:', error);
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('notify.load-orderlist-error', 'Сталася помилка при завантаженні списку замовлень'),
          type: 'error',
          duration: 3000
        });
      }
    },

    getItemTitle(item) {
      return item.info.busked.map(i => i.title).join(' | ')
    },
    openChat(event, item) {
      window.openChat(
        {
          id: item.id,
          chat_id: item.user.telegram.user_id,
          name: item.user.telegram.username,
          startX: event.clientX,
          startY: event.clientY
        })
    },
    async remove() {
      try {
        await api.delete('/api/order/' + this.selected.id);
        await this.getItems();

        this.$notify({
          title: this.$static('order-remove-title', 'Видалення замовлення'),
          text: this.$static('order-success-remove-text1', 'Замовлення №') + `${this.selected.id}` + this.$static('order-success-remove-text2', ' видалено успішно'),
          duration: 2000
        });

        this.selected = undefined;

        this.closeRemoveConfirmationModal();
      } catch (error) {
        console.error('Error removing order:', error);
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('order.remove-error', 'Сталася помилка при видаленні замовлення'),
          type: 'error',
          duration: 3000
        });
      }
    },

    openEditor(item, event) {
      if (!item.delivery) {
        item.delivery = {}
      }
      window.openOrder(item);
    },

    openRemoveConfirmationModal(item) {
      this.selected = item;
      window.$('body').addClass('is-hidden');
      window.$('.back-blur').toggleClass('active');
      window.$('.remove-order-confirmation-modal').toggleClass('active');
    },

    closeRemoveConfirmationModal() {
      this.selected = undefined;
      window.$('body').removeClass('is-hidden');
      window.$('.back-blur').removeClass('active');
      window.$('.remove-order-confirmation-modal').removeClass('active');
    },

    onSave(item) {
      item.created_at = new Date(item.created_at);
      item.updated_at = new Date(item.updated_at);
      let idx = this.items.findIndex(i => i.id === item.id);
      if (idx > -1) {
        this.items[idx] = item;
      }
    },
    onAdd(item) {
      this.items.unshift(item)
    }
  },
  watch: {
    async page(val) {
      this.filter.page = val;
      await this.getItems();
    },
    async 'filter.pay_status'() {
      await this.getItems();
    },
    async 'filter.status'() {
      await this.getItems();
    },
    async orderDate() {
      await this.getItems();
    }
  }
}
</script>

<style scoped>
.remove-order-confirmation-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  /* transform: translate(-50%, -50%); */
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transition: all .2s cubic-bezier(.165, .84, .44, 1);
  -webkit-transition: all .2s cubic-bezier(.165, .84, .44, 1);
  transition-delay: 0s;

  &.active {
    opacity: 1;
    visibility: visible;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    transition: all .2s cubic-bezier(.165, .84, .44, 1);
    -webkit-transition: all .2s cubic-bezier(.165, .84, .44, 1);
  }

  .modal-header-noborder {
    border-bottom: none;
  }

  .button-holder-center-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
